module.exports = __webpack_public_path__ + "img/wechat.03883c8e.svg";